import { node, object } from "prop-types";
import { useTranslation } from "react-i18next";
import { SummaryColumns } from "@repo/utils";
import {
  useEstimateEditorSettings,
  useEstimateTableSettings,
  useEstimateEditorStore,
  PinnableCell,
} from "@tools";
import { SummaryRowActions, WorkTypeSelect } from "./components";
import classnames from "classnames";

export const TitleCell = ({
  workType,
  children,
}) => {
  const { t } = useTranslation();
  const { visibilityMode } = useEstimateEditorStore();
  const { useExpandCell } = useEstimateTableSettings();
  const { allowEdition, useProfitability } = useEstimateEditorSettings();
  
  const { name, isOpened } = workType;
  
  return (
    <PinnableCell
      boldText keepMinSize
      colName={ SummaryColumns.TITLE }
      pinnedLeft
      tableDepth={1}
      allowOverflowDisplay
      actions={
        !useProfitability &&
        <SummaryRowActions workType={workType} opened={isOpened}/>
      }
      containers={ children }
      pinActionsLeft={!useProfitability && !visibilityMode}
      actionsContainerWidth={6*24}
    >
      {
        allowEdition && !useProfitability
          ? <WorkTypeSelect
            workType={workType}
            useExpandCell={useExpandCell}
          />
          : <span
            className={classnames(
              "name",
              "preset-summaryTitleText",
              !name?.length && "semi-transparent",
              !useExpandCell && "ml-3"
            )}
          >
            { name || t("common.unnamed") }
          </span>
      }
    </PinnableCell>
  )
}

TitleCell.propTypes = {
  workType: object.isRequired,
  children: node
}